import Image from 'next/image';
import Link from 'next/link';
import { c } from '../../../utils/tailwind-merge';
import { Label } from '../../atoms/Label/Label';
import { MyAssetDetailProps } from './MyAssetDetail.types';

export const MyAssetDetail = ({
  status,
  productImageUrl,
  name,
  nameLink,
  publisherName,
  publisherNameLink,
  purchasedDate,
  lastUpdatedDate,
  organization,
  microcopy,
  className = '',
}: MyAssetDetailProps) => {
  const statusLabelMap = {
    deprecated: microcopy.deprecated,
    disabled: microcopy.disabled,
  };
  const statusLabel = status ? statusLabelMap[status] : null;

  return (
    <div
      data-test="my-asset-detail"
      className={c(
        'flex w-full text-grey-700 lg:justify-between lg:gap-12',
        className
      )}
    >
      <div className="flex w-full gap-12">
        <div className="flex w-full gap-4 lg:w-fit">
          <div className="relative h-[57px] w-[86px] shrink-0 lg:h-[90px] lg:w-[134px]">
            <Image
              fill
              alt=""
              aria-hidden={true}
              src={productImageUrl}
              className={c(
                'rounded-lg',
                status && 'opacity-40 mix-blend-luminosity'
              )}
            />
          </div>

          <div className="flex min-w-0 flex-col gap-3 lg:w-56">
            <div>
              <h3 data-test="asset-title" className="truncate text-base">
                <Link href={nameLink}>{name}</Link>
              </h3>
              <div data-test="publisher-name" className="text-sm">
                <Link href={publisherNameLink}>{publisherName}</Link>
              </div>
              <div className="hidden space-x-1 lg:block">
                <span className="text-sm">{microcopy.purchasedDate}</span>
                <span className="text-sm">{purchasedDate}</span>
              </div>
              <div className="hidden space-x-1 lg:block">
                <span className="text-sm">{microcopy.organization}</span>
                <span className="text-sm">{organization}</span>
              </div>
            </div>
            <div className="block space-x-1 lg:hidden">
              <span className="text-sm">{microcopy.purchasedDate}</span>
              <span className="text-sm">{purchasedDate}</span>
            </div>
            {!status && lastUpdatedDate && (
              <div className="block space-x-1 lg:hidden">
                <span className="text-sm">{microcopy.lastUpdated}</span>
                <span className="text-sm">{lastUpdatedDate}</span>
              </div>
            )}
            {statusLabel && (
              <div className="block lg:hidden">
                <Label appearance="alert" text={statusLabel} />
              </div>
            )}
          </div>
        </div>

        <div className="hidden lg:block">
          {!status && lastUpdatedDate && (
            <div className="space-x-1">
              <span className="text-sm">{microcopy.lastUpdated}</span>
              <span className="text-sm">{lastUpdatedDate}</span>
            </div>
          )}
          {statusLabel && <Label appearance="alert" text={statusLabel} />}
        </div>
      </div>
    </div>
  );
};
